import React, { useContext, useEffect, useState } from "react";
import { Image, ListGroup } from "react-bootstrap";
import FormControl from "react-bootstrap/FormControl";
import { Store } from "../Store";
import useProductsAndCategories from "../hooks/useProductsAndCategories";
import { turkishCurrencyFormatterNoPrecision } from "../utils";
import FiliskaPagination from "./FiliskaPagination";

export default function ProductTableForMenu(props) {
  const { productAddHandler, setShowSelectProduct } = props;

  const { state } = useContext(Store);
  const { products } = state;
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(props.page ? props.page : 1);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const PAGE_SIZE = 3;
  const [pages, setPages] = useState(1);
  const [product, setProduct] = useState(null);

  useProductsAndCategories();

  useEffect(() => {
    const productsFiltered = products
      ?.filter((p) =>
        query
          ? p.name.toLocaleLowerCase().includes(query.toLocaleLowerCase())
          : true
      )
      .filter((p, i) => {
        if ((page - 1) * PAGE_SIZE <= i && i < page * PAGE_SIZE) {
          return true;
        }
        return false;
      });
    setFilteredProducts(productsFiltered || []);
  }, [page, query]);

  useEffect(() => {
    products && setPages(Math.ceil(products.length / PAGE_SIZE));
  }, [pages]);

  return (
    <div>
      {!product ? (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FormControl
              className="mb-2"
              type="text"
              size="lg"
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                setPage(1);
              }}
              placeholder="Urun ara..."
              aria-label="Urun ara"
              aria-describedby="button-search"
            ></FormControl>

            {filteredProducts?.map((product) => (
              <div
                className="mb-2 border border-light rounded"
                key={product._id}
              >
                <ListGroup.Item
                  action
                  onClick={() => {
                    if (product.features && product.features.length > 0) {
                      setProduct(product);
                    } else {
                      productAddHandler(product);
                      setShowSelectProduct(false);
                    }
                  }}
                  className="bg-light  btn btn-outline-primary"
                >
                  <div>
                    <Image
                      style={{ float: "left", marginRight: "0.5rem" }}
                      className="small-product-image"
                      src={product.image}
                      alt={product.name}
                      fluid
                      rounded
                    ></Image>
                    <h5 style={{ display: "inline" }}>{product.name}</h5>
                    &nbsp;&nbsp;
                    <span>
                      {turkishCurrencyFormatterNoPrecision(product.price)}
                    </span>
                  </div>
                  {product.no && (
                    <div className="small-font text-muted">
                      No: {product.no}
                    </div>
                  )}
                </ListGroup.Item>
              </div>
            ))}
          </div>
          <div className="ms-2">
            <FiliskaPagination
              leftRightSize={1}
              page={page}
              pages={pages}
              onFirst={() => setPage(1)}
              onLast={() => setPage(pages)}
              onNext={() => {
                if (page < pages) {
                  setPage(page + 1);
                }
              }}
              onPrev={() => {
                if (page > 1) {
                  setPage(page - 1);
                }
              }}
              onItemNext={(p) => setPage(p)}
              onItemPrev={(p) => setPage(p)}
            ></FiliskaPagination>
          </div>
        </>
      ) : (
        <div>
          {product?.features.map((f) => (
            <div className="mb-2 border border-light rounded" key={f._id}>
              <ListGroup.Item
                action
                onClick={() => {
                  productAddHandler(product, f);
                  setShowSelectProduct(false);
                }}
                className="p-2 bg-light  btn btn-outline-primary"
              >
                <div>
                  <h5 style={{ display: "inline" }}>
                    {f.name + " " + product.name}
                  </h5>
                  &nbsp;&nbsp;&nbsp;
                  <span>
                    {turkishCurrencyFormatterNoPrecision(
                      product.price + f.price
                    )}
                  </span>
                </div>
              </ListGroup.Item>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
